import {Injectable} from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot} from '@angular/router';
import {GraspService} from './grasp.service';

@Injectable()
export class OrganizationGuardService implements CanActivate {

    constructor(private router: Router, private graspService: GraspService) {

    }

    canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
        return new Promise((resolve) => {
            this.graspService.getOrganization()
                .then((organization) => {
                    if (organization) {
                        resolve(true);
                    } else {
                        this.router.navigate(['select-organization']);
                        resolve(false);
                    }
                })
                .catch(err => {
                    this.router.navigate(['select-organization']);
                    resolve(false);
                });
        })
    }
}
